import React from "react"
import "./metrics.css"
const Metrics = () => {
  const metricsData = [
    {
      id: 1,
      stat: "30%",
      title: "API Performance Boost",
      description: "Reduced latency across platforms",
      colorClass: "black-white-metric",
      // Performance graph trend SVG icon
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
          <polyline points="17 6 23 6 23 12"></polyline>
        </svg>
      ),
    },
    {
      id: 2,
      stat: "99.9%",
      title: "System Uptime",
      description: "Maintained across platforms",
      colorClass: "black-white-metric",
      // Clock Uptime SVG icon
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      ),
    },
    {
      id: 3,
      stat: "5+",
      title: "Years Experience",
      description: "In AI-enabled SaaS development",
      colorClass: "black-white-metric",
      // Brain / Intelligence SVG icon
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.44 2.5 2.5 0 0 1 0-3.12 3 3 0 0 1 0-4.88 2.5 2.5 0 0 1 0-3.12A2.5 2.5 0 0 1 9.5 2z"></path>
          <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.44 2.5 2.5 0 0 0 0-3.12 3 3 0 0 0 0-4.88 2.5 2.5 0 0 0 0-3.12A2.5 2.5 0 0 0 14.5 2z"></path>
        </svg>
      ),
    },
  ]

  return (
    <section className="metrics-container">
      <div className="metrics-grid">
        {metricsData.map(item => (
          <div key={item.id} className="metric-card">
            <div className={`icon-circle ${item.colorClass}`}>
              {item.icon}
            </div>
            <h2 className="metric-stat">{item.stat}</h2>
            <h3 className={`metric-title ${item.colorClass}`}>{item.title}</h3>
            <p className="metric-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Metrics